/**
 * Screens where Unity `World` is mounted and `GlobalLoadingOverlay` (App.js) owns the full-screen loader.
 */
export const SCREENS_WITH_UNITY_WORLD = ['meeting', 'avatarPreview'];
